<template>
	<div class="header-wrap">
		<header class="home-navbar">
			<a class="home-navbar__logo">
				<img src="@/assets/images/logo.png" alt="" />
			</a>
			<div class="home-navbar__nav">
				<nav class="home-navbar__nav-links">
					<div
						class="home-navbar__nav-item"
						:class="{
							'home-navbar__nav-item--active':
								$route.path.includes(nav.name) ||
								($route.path === '/' && nav.name === 'Home'),
						}"
						v-for="nav in navList"
						:key="nav.title"
					>
						<router-link
							v-if="!nav.children || nav.children.length === 0"
							:to="nav.path"
							tag="div"
							slot="reference"
						>
							<p class="zh">{{ nav.title }}</p>
							<p class="en">{{ nav.title_en }}</p>
						</router-link>
						<el-popover trigger="hover" v-else>
							<ul class="home-navbar__nav-children">
								<router-link
									class="home-navbar__nav-children-item"
									:class="{
										'home-navbar__nav-children-item--active':
											$route.path === navChild.path,
									}"
									tag="li"
									:to="navChild.path"
									v-for="navChild in nav.children"
									:key="navChild.path"
								>
									{{ navChild.title }}
								</router-link>
							</ul>

							<div slot="reference">
								<p class="zh">{{ nav.title }}</p>
								<p class="en">{{ nav.title_en }}</p>
							</div>
						</el-popover>
					</div>
					<a
						class="home-navbar__nav-item login-btn"
						href="https://www.gzstp.com/login/"
					>
						登录
					</a>
				</nav>
			</div>
		</header>
	</div>
</template>

<script>
export default {
	props: {},
	data() {
		return {}
	},
	computed: {},
	inject: ['navList'],
	created() {
		//console.log(this.navList)
	},
	mounted() {},
	watch: {},
	methods: {},
	components: {},
}
</script>

<style lang="scss">
.header-wrap {
	width: 100%;
	background-color: #ffffff;
}

.home-navbar {
	padding: 22px 0;
	align-items: center;
	margin: 0 auto;
	width: 1200px;

	&__logo {
		display: inline-block;
		vertical-align: top;
		flex-shrink: 0;
		font-size: 0;

		& > img {
			width: 144px;
			height: 80px;
		}
	}

	&__nav {
		display: inline-block;
		vertical-align: top;
		margin-left: 90px;

		&-links {
			display: flex;
			align-items: center;
		}

		&-item {
			padding: 10px 0;
			text-align: center;
			flex-shrink: 0;
			cursor: pointer;

			& + & {
				margin-left: 60px;
			}

			& .zh {
				font-size: 18px;
			}

			& .en {
				font-size: 12px;
				color: $desc-color;
			}

			&.login-btn {
				display: block;
				padding: 8px 45px;
				cursor: pointer;
				border-radius: 18px;
				color: #fff;
				background-color: $active-color;
				margin-bottom: 14px;
				margin-left: 75px;
				text-decoration: unset;

				&:active {
					color: rgba(255, 255, 255, 0.8);
				}
			}

			&--active {
				& .zh,
				& .en {
					color: $active-color;
				}
			}
		}
		&-children {
			font-size: 14px;
			color: rgba(0, 0, 0, 0.45);
			text-align: center;
			&-item {
				cursor: pointer;
				padding: 10px 4px;
				&--active {
					color: $active-color;
				}
			}
		}
	}
}
</style>
